import { render } from "./SupportListPage.vue?vue&type=template&id=3c2eb756&scoped=true"
import script from "./SupportListPage.vue?vue&type=script&lang=js"
export * from "./SupportListPage.vue?vue&type=script&lang=js"

import "./SupportListPage.vue?vue&type=style&index=0&id=3c2eb756&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2eb756"]])

export default __exports__